import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { PreviewMailModel } from '../../models/mail/preview-mail.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { MailFacade } from '../../shared-new/store/mail/mail.facade';

@Component({
  selector: 'app-preview-mail-popup',
  templateUrl: './preview-mail-popup.component.html',
  styleUrls: ['./preview-mail-popup.component.scss']
})
export class PreviewMailPopupComponent extends BaseUnsubscribeComponent implements OnInit {
  @Input() public data: any;
  public emailText: string;
  public smsText: string;
  public subject: string;
  constructor(public readonly modal: NgbActiveModal, private readonly mailFacade: MailFacade ) {
      super();
  }

  ngOnInit(): void {
    const previewRequestModel: PreviewMailModel = this.data?.previewRequestModel;
    this.mailFacade.previewMail(previewRequestModel);
    this.mailFacade.previewMail$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      this.emailText = response?.emailBodyText;
      this.smsText = response?.smsBodyText;
      this.subject = response?.subject;
    })
  }

}
